export default "__VITE_ASSET__CJxmBmeu__"